import { mapMutations, mapState } from 'vuex';
import EventBus from '@/event-bus';

export default {
  data() {
    return {
      isDisabled: false,
    };
  },
  props: {
    tags: {
      type: Object,
      default() { return {}; },
    },
    queryKeys: {
      type: Object,
      default() { return {}; },
    },
    title: {
      type: String,
      default: '',
    },
    fallbackCount: {
      type: Number,
      default: 0,
    },
  },
  created() {
    EventBus.$on('bus:disable-all-filters-while-search-request-is-being-processed', this.disableInput);
    EventBus.$on('bus:enable-all-filters-after-search-request-is-processed', this.enableInput);
  },
  beforeDestroy() {
    // @todo brunoTodo review with joe because when changing "Filter By" the $off were breaking the be
    // EventBus.$off('bus:disable-all-filters-while-search-request-is-being-processed');
    //  EventBus.$off('bus:enable-all-filters-after-search-request-is-processed');
  },
  methods: {
    ...mapMutations('search', {
      updateQueryFilters: 'updateQueryFilters',
      updateSearchUrl: 'updateSearchUrl',
    }),
    disableInput() {
      this.isDisabled = true;
    },
    enableInput() {
      this.isDisabled = false;
    },
    updateQueryInStore(tag) {
      if (this.isDisabled) {
        return;
      }
      if (!Array.isArray(this.filterQuery)) return;

      const isValueAlreadySelected = this.filterQuery.some((filter) => filter === tag.key);

      if (isValueAlreadySelected) {
        this.updateSearchUrl(tag.url_without_filter);
        this.updateQueryFilters({
          filterValues: this.filterQuery.filter((filter) => filter !== tag.key),
          filterName: this.queryKeys.values,
        });
      } else if (tag.count > 0 || this.showCount === false) {
        this.updateSearchUrl(tag.url);
        this.updateQueryFilters({
          filterValues: [...this.filterQuery, tag.key],
          filterName: this.queryKeys.values,
        });
      }
    },
    anchorRelAttributeValue(tag) {
      if (tag.name === 'Top Employers' || tag.name === 'Best Student Employers') {
        return 'nofollow';
      }

      return tag.a_with_rel_nofollow ? 'nofollow' : null;
    },
    isValueDisabled(tag) {
      if (tag.count !== 0 || this.showCount === false) { return false; }

      return !this.filterQuery.some((filter) => filter === tag.key);
    },
  },

  computed: {
    filterQuery: {
      get() {
        return this.$store.state.search.query[this.queryKeys.values];
      },
    },
    hasFilters() {
      return this.tags.length || (this.tags.groups && this.tags.groups.length > 0);
    },

    ...mapState('search', {
      showCount: (state) => !state.ignoreAggregations,
    }),
  },
};
